import { DateFormats, formatDate } from '@strata/helper-functions';
import { FormSection } from '@strata/react-form-section';
import { type ColumnDefGeneric, Grid, SecondaryData } from '@strata/react-grid';
import { Tag } from '@strata/react-tags';
import { useNavigate, useParams } from 'react-router';

import { AppRoutes } from 'services/routes';
import { type ClaimHistoryRecord } from 'store/api/medbillingApi';

const initialSortProperties = [{ id: 'submittedDate', desc: true }];

/* eslint-disable react/prop-types */
const SubmissionDateCell: ColumnDefGeneric<ClaimHistoryRecord, 'submittedDate'>['cell'] = ({
    getValue,
    row,
}) => {
    const { transactionId } = useParams();
    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <SecondaryData data={formatDate(getValue(), DateFormats.DATE_TIME)} />
            {row.original.transactionId === transactionId && (
                <Tag label="Currently Viewing" className="margin__left--medium" />
            )}
        </div>
    );
};
/* eslint-enable react/prop-types */

interface ClaimHistoryProps {
    history: ClaimHistoryRecord[];
}

export const ClaimHistory = ({ history }: ClaimHistoryProps) => {
    const { payerId, transactionId } = useParams();
    const navigate = useNavigate();

    return (
        <FormSection
            sectionTitle="Claim History"
            content={
                <Grid
                    data={history}
                    sortProperties={initialSortProperties}
                    onRowClick={(rowData) => {
                        if (rowData.transactionId !== transactionId) {
                            navigate(AppRoutes.claimDetails(payerId, rowData.transactionId));
                        }
                    }}
                    columns={[
                        {
                            accessorKey: 'submittedDate',
                            header: 'Submission Date',
                            size: 150,
                            cell: SubmissionDateCell,
                        },
                        {
                            accessorKey: 'transactionId',
                            header: 'Transaction ID',
                            size: 150,
                        },
                        {
                            accessorKey: 'comment',
                            header: 'Reason',
                            size: 150,
                        },
                        {
                            accessorKey: 'username',
                            header: 'Submitted By',
                            size: 200,
                        },
                    ]}
                />
            }
        />
    );
};
